// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sidebar[data-v-fee1416a]{position:relative;height:100%;width:89px}.sidebar-fixed[data-v-fee1416a]{position:fixed;top:64px;left:0;bottom:0;padding:24px;background-color:#fff;border-right:1px solid #f1f5fc}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
